import React from "react";
//import BingoGame from "./UserBingoBoard_updated";
import BingoGame from "./UserBingoBoard";


type BingoWrapperProps = {
  username: string;
};

const BingoWrapper: React.FC<BingoWrapperProps> = ({ username}) => {
  return <BingoGame username={username}  />;
};

export default BingoWrapper;
